import axios from 'axios';

// Auto-switch API URL berdasarkan environment (Local vs Develop vs Production)
export let API_BASE_URL = 'https://satudata.sampangkab.go.id/api'; // Default Production

if (window.location.hostname === 'localhost') {
    API_BASE_URL = 'http://localhost:1104/api'; // Arahkan localhost ke server Develop agar bisa ngetes tanpa nyalakan backend lokal
} else if (window.location.hostname === '10.10.0.99') {
    API_BASE_URL = 'http://10.10.0.99/api'; // Develop Server
}

export const MockStatsService = {
    // 1. Mendapatkan statistik pengunjung untuk Footer
    getVisitorStats: async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/stats/portal`);
            const data = response.data;
            // Validasi: pastikan respons adalah JSON yang benar (bukan HTML dari Nginx)
            if (data && typeof data === 'object' && 'today' in data) {
                return data;
            }
            return { today: 0, thisWeek: 0, thisMonth: 0, totalHits: 0 };
        } catch (error) {
            console.error('VisitorStats Fetch Error:', error);
            return { today: 0, thisWeek: 0, thisMonth: 0, totalHits: 0 };
        }
    },

    // 2. Mendapatkan statistik global untuk Beranda
    getGlobalStats: async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/stats/portal`);
            const data = response.data;
            if (data && typeof data === 'object' && 'totalHits' in data) {
                return {
                    datasetCount: 0,
                    priorityDataCount: 660,
                    downloadCount: data.totalDownloads || 0,
                    visitorCount: data.totalHits || 0
                };
            }
            return { datasetCount: 0, priorityDataCount: 660, downloadCount: 0, visitorCount: 0 };
        } catch (error) {
            console.error('GlobalStats Fetch Error:', error);
            return { datasetCount: 0, priorityDataCount: 660, downloadCount: 0, visitorCount: 0 };
        }
    },

    // 3. Mendapatkan view untuk dataset tertentu
    getDatasetStat: async (datasetId) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/stats/dataset/${datasetId}`);
            return { views: response.data.views, downloads: response.data.downloads };
        } catch (error) {
            return { views: 0, downloads: 0 };
        }
    },

    // 4. Memicu rekaman kunjungan portal saat halaman dimuat
    logVisitor: async () => {
        try {
            await axios.post(`${API_BASE_URL}/visitors`);
        } catch (error) {
            // Abaikan error secara halus
        }
    },

    // 5. Menaikkan view dataset
    incrementDatasetStat: async (datasetId, type = 'view') => {
        try {
            await axios.post(`${API_BASE_URL}/stats/dataset/${datasetId}/interaction?action=${type}`);
        } catch (error) {
            console.error('Increment error:', error);
        }
    }
}